import { siteApiSlice } from "../../../app/siteApiSlice";
import { StimulusMaterialViewModel } from "../../stimulusMaterial/stimulusMaterialApiSlice";

// The SPA currently doesn't support the TAP organizer
export const TAP_GUIDE_ORGANIZER_ID = 6;
export const TAP_GUIDE_ORGANIZER_NAME = "TAP Count Planning Guide";

export interface SelectOrganizerDto {
	id: number;
	name: string;
	thumbURL: string;
	formattedName: string;
}

export interface SelectOrganizerEditModel {
	organizerId: number | null;
	promptId: number | null;
	draftId: number | null;
}

export const NullSelectOrganizerEditModel: SelectOrganizerEditModel = {
	organizerId: null,
	promptId: null,
	draftId: null,
};

export interface SelectOrganizerViewModel {
	recommendedOrganizers: SelectOrganizerDto[];
	otherOrganizers: SelectOrganizerDto[];
	editModel: SelectOrganizerEditModel;
	allowPrevious: boolean;
	graphicOrganizersUrl: string; // support URL
	requiredOrganizer: SelectOrganizerDto | null;
}

export interface OrganizeEditModel {
	draftId: number;
	draftStatus: string;
	name: string;
	response: string;
	html: string;
	promptName: string;
	renderedPromptText: string;
	stimulusMaterials: StimulusMaterialViewModel[];
	signLanguageVideoURL: string;
	autosaveIntervalSeconds: number;
	showMessages: boolean;
	organizerRequired: boolean;
}

export interface SaveOrganizerModel {
	draftId: number;
	organizerResponse: string;
}

export interface OrganizerValidationResponse {
	status: string;
	message: string;
}

export interface OrganizerViewModel {
	htmlTemplate: string;
	organizerResponse: string;
	isVisibleByDefault: boolean;
}

export const organizingApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		selectOrganizerByPrompt: build.query<SelectOrganizerViewModel, number>({
			query: (promptId) => ({
				url: `/Draft/SelectOrganizerByPrompt`,
				params: { promptId },
			}),
		}),
		selectOrganizerByDraft: build.query<SelectOrganizerViewModel, number>({
			query: (draftId) => ({
				url: `/Draft/SelectOrganizerByDraft`,
				params: { draftId },
			}),
		}),
		graphicOrganizerPrintableLink: build.query<{ url: string }, number>({
			query: (organizerId) => ({
				url: `/Draft/GraphicOrganizerPrintableLink`,
				params: { organizerId },
			}),
		}),
		selectOrganizer: build.mutation<{ draftId: number }, SelectOrganizerEditModel>({
			query: (payload) => ({
				url: `/Draft/SelectOrganizer`,
				method: "POST",
				body: payload,
			}),
			invalidatesTags: ["Prompts", "WritingHistory"],
		}),
		organize: build.query<OrganizeEditModel, number>({
			query: (draftId) => ({
				url: `/Draft/Organize`,
				params: { draftId },
			}),
			providesTags: ["Prompts", "WritingHistory"],
		}),
		saveOrganizer: build.mutation<OrganizerValidationResponse, SaveOrganizerModel>({
			query: (payload) => ({
				url: `/Draft/AutosaveOrganizer`,
				method: "POST",
				body: payload,
			}),
			invalidatesTags: ["Prompts", "WritingHistory"],
		}),
	}),
});

export const {
	useSelectOrganizerByPromptQuery,
	useSelectOrganizerByDraftQuery,
	useLazyGraphicOrganizerPrintableLinkQuery,
	useSelectOrganizerMutation,
	useOrganizeQuery,
	useSaveOrganizerMutation,
} = organizingApiSlice;
